import Handler from "../Handler";
class DealStatusHandler extends Handler {
    /**DealStatus#{"tourneyId":"wzpud","optedCount":0,"currentPlayerCount":2,"playersList":[]} */
    // This handler is used to handle the DealStarted event.
    // The message format is:
    //   {"tourneyId":"wzpud","optedCount":0,"currentPlayerCount":2,"playersList":[]}
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processDealStatusProtocol(receivedData);
  }
}
export default DealStatusHandler;
